import { render, staticRenderFns } from "./IconQuestion.vue?vue&type=template&id=6c1ff00d&scoped=true&lang=pug&"
import script from "./IconQuestion.vue?vue&type=script&lang=js&"
export * from "./IconQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ff00d",
  null
  
)

export default component.exports